module.exports = __webpack_public_path__ + "static/Verso-c005bafe2687152c694c8232e1a00d90.png";